import ButtonBase from '@material-ui/core/ButtonBase';
import classNames from 'classnames';
import React, { FC } from 'react';

import ArrowDown from '../images/arrow-down.svg';
import ArrowUp from '../images/arrow-up.svg';
import useStyles from './styles';

export interface NextPreviousButtonProps {
  className?: string;
  /** Translated name for the next button, e.g. "Next applicant". */
  nextLabel: string;
  onNext: () => void;
  onNextDisabled?: boolean;
  onPrevious: () => void;
  onPreviousDisabled?: boolean;
  /** Translated name for the previous button, e.g. "Previous applicant". */
  previousLabel: string;
}

export const NextPreviousButton: FC<NextPreviousButtonProps> = ({
  className,
  nextLabel,
  onNext,
  onNextDisabled,
  onPrevious,
  onPreviousDisabled,
  previousLabel,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, className)}>
      <ButtonBase
        aria-label={previousLabel}
        classes={{ disabled: classes.buttonDisabled }}
        className={classNames(classes.button, classes.previous)}
        disabled={onPreviousDisabled}
        onClick={onPrevious}
      >
        <img alt="" src={ArrowUp} />
      </ButtonBase>
      <ButtonBase
        aria-label={nextLabel}
        classes={{ disabled: classes.buttonDisabled }}
        className={classNames(classes.button, classes.next)}
        disabled={onNextDisabled}
        onClick={onNext}
      >
        <img alt="" src={ArrowDown} />
      </ButtonBase>
    </div>
  );
};

export default NextPreviousButton;
